
import { Component } from 'react';
import { Button, capitalize, Dialog, DialogActions, DialogContent, Divider, MenuItem, TextField } from '@mui/material';
import DialogTitleWithCloseButton from '../../../components/DialogTitleWithCloseButton';
import { connect } from 'react-redux';
import { GENDER } from '../../../../../shared/constants';
import { errorToast } from '../../../toast';
import { returnChangedAttributes } from '../../../utils';
import { showLoading, hideLoading } from '../../../loading';
import request from '../../../request';
import actions from '../../../redux/actions';
import swal from 'sweetalert';
import Image from '../../../components/Image';
import Edit from '@mui/icons-material/Edit';
import ImageInput from '../../../components/ImageInput';



class _ProfileEditor extends Component {

   state = {
      name: this.props.user.name,
      surname: this.props.user.surname,
      gender: this.props.user.gender,
      email: this.props.user.email,
      editingProfilePicture: false,
   }

   submit = async () => {

      // validate form
      const { name, surname, email, gender } = this.state;

      if (!name) {
         errorToast('Name is required');
         return document.getElementById('txt-name').focus();
      }

      if (!surname) {
         errorToast('Surname is required');
         return document.getElementById('txt-surname').focus();
      }

      if (!gender) {
         errorToast('Gender is required');
         return document.getElementById('txt-gender').focus();
      }

      if (!email) {
         errorToast('Email is required');
         return document.getElementById('txt-email').focus();
      }

      // get payload
      const payload = returnChangedAttributes({
         name,
         surname,
         gender,
         email: email.toLowerCase(),
      }, this.props.user);

      if (Object.keys(payload).length === 0) {
         errorToast('No changes detected');
         return this.props.onClose();
      }

      // send payload
      try {

         showLoading('Updating profile');

         const res = await request.patch('/api/auth/profile', payload);
         actions.setUser(res.data);

         this.props.onClose();

         let message = 'Profile updated successfully';

         if (payload.email)
            message += '. To complete the email change, please check your email to verify.';

         swal('Success', message, 'success');

      } catch (err) {
         swal('Error', err.message, 'error');
      } finally {
         hideLoading();
      }

   }

   startEditingProfilePicture = () => {
      this.setState({ editingProfilePicture: true });
   }

   stopEditingProfilePicture = async (profilePicture) => {

      if (profilePicture) {
         try {
            showLoading('Updating profile picture');

            const data = { ...profilePicture, name: 'picture.png' }
            const res = await request.post('/api/auth/profile-picture', data);

            actions.setUser(res.data);

         } catch (err) {
            swal('Error', err.message, 'error');
            return; // don't close the dialog
         } finally {
            hideLoading();
         }
      }

      this.setState({ editingProfilePicture: false });
   }

   render() {
      return <Dialog open fullWidth maxWidth="xs">
         <DialogTitleWithCloseButton onClose={this.props.onClose}>
            Edit Profile
         </DialogTitleWithCloseButton>
         <DialogContent dividers>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>

               <div className='col-span-full flex justify-center'>
                  <div className=''>
                     {
                        !this.state.editingProfilePicture && <div className='w-[150px] flex flex-col justify-center gap-2'>
                           <Image
                              className="w-full rounded-full overflow-hidden"
                              src={this.props.user.profile_picture}
                           />
                           <Button onClick={this.startEditingProfilePicture} startIcon={<Edit />}>
                              Edit
                           </Button>
                        </div>
                     }
                     {
                        this.state.editingProfilePicture && <ImageInput
                           aspectRatio={1}
                           circularCrop
                           onClose={this.stopEditingProfilePicture}
                        />
                     }
                  </div>
               </div>

               <Divider className='col-span-full' />

               <TextField
                  id='txt-name'
                  label='Name'
                  value={this.state.name}
                  onChange={e => this.setState({ name: e.target.value })}
                  size='small'
                  variant='outlined'
                  fullWidth
               />
               <TextField
                  id='txt-surname'
                  label='Surname'
                  value={this.state.surname}
                  onChange={e => this.setState({ surname: e.target.value })}
                  size='small'
                  variant='outlined'
                  fullWidth
               />
               <TextField
                  id='txt-gender'
                  label="Gender"
                  value={this.state.gender}
                  onChange={e => this.setState({ gender: e.target.value })}
                  size='small'
                  variant='outlined'
                  fullWidth
                  select
               >
                  {
                     Object
                        .values(GENDER)
                        .map(
                           value => <MenuItem
                              key={value}
                              value={value}
                           >
                              {capitalize(value)}
                           </MenuItem>
                        )
                  }
               </TextField>
               <TextField
                  id='txt-email'
                  label='Email'
                  value={this.state.email}
                  onChange={e => this.setState({ email: e.target.value })}
                  size='small'
                  variant='outlined'
                  fullWidth
               />
            </div>
         </DialogContent>
         <DialogActions>
            <Button variant='contained' onClick={this.submit}>
               SAVE
            </Button>
         </DialogActions>
      </Dialog>
   }
}


const mapStateToProps = state => ({ user: state.user });
const ProfileEditor = connect(mapStateToProps)(_ProfileEditor);

export default ProfileEditor;